module.exports = __webpack_public_path__ + "static/media/c-programming.1df85772.svg";